<div class="app-container">
  <app-sidebar />

  <div class="app-layout">
    <app-topbar />
    <main class="app-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>